import http from "../http-common";
class ManagerDataService {
  habilitation(email) {
    return http.get(`/manager/habilitation?email=${email}`);
  }
  getRecetteMngCount(email) {
    return http.get(`/manager/recette-mng/count?email=${encodeURIComponent(email)}`);
  }
  getRecetteStructureYears(email) {
    return http.get(`/manager/recette-structure/years?email=${encodeURIComponent(email)}`);
  }
  getRecetteStructure(email, year) {
    const y = year ? `&year=${encodeURIComponent(year)}` : "";
    return http.get(`/manager/recette-structure?email=${encodeURIComponent(email)}${y}`);
  }
  mngdisplay(email) {
    return http.get(`/manager/mngdisplay?email=${email}`);
  }
  service(email) {
    return http.get(`/manager/service?email=${email}`);
  }
  allDoctors() {
    return http.get(`/manager/alldoctors`);
  }
  addPlanningPlann(serv,doc,prix,jr,hdeb,hfin,maxpatient,myuser) {
    return http.get(`/manager/createplanningplann?serv=${serv}&doc=${doc}&prix=${prix}&jr=${jr}&hdeb=${hdeb}&hfin=${hfin}&maxpatient=${maxpatient}&myuser=${myuser}`);
  }
  addPlann(idplanning,doc,jr,hdeb,hfin,maxpatient,myuser) {
    return http.get(`/manager/createplann?idplanning=${idplanning}&doc=${doc}&jr=${jr}&hdeb=${hdeb}&hfin=${hfin}&maxpatient=${maxpatient}&myuser=${myuser}`);
  }
  updateTarif(prix,email,idplanning) {
    return http.put(`/manager/updatetarif?prix=${prix}&email=${email}&idplanning=${idplanning}`);
  }
  updateQuota(quota,email,idplann) {
    return http.put(`/manager/updatequota?quota=${quota}&email=${email}&idplann=${idplann}`);
  }
  deletePlann(idplann,myuser) {
    return http.get(`/manager/deleteplann?idplann=${idplann}&myuser=${myuser}`);
  }
  addIndisPlann(debut,fin,motif,idplann,myuser) {
    return http.get(`/manager/addindisplann?debut=${debut}&fin=${fin}&motif=${motif}&idplann=${idplann}&myuser=${myuser}`);
  }
  endIndisPlann(fin,email,idindis) {
    return http.put(`/manager/endindisplann?fin=${fin}&email=${email}&idindis=${idindis}`);
  }
  extendIndisPlann(fin,idindis,myuser) {
    return http.get(`/manager/extendindisplann?fin=${fin}&idindis=${idindis}&myuser=${myuser}`);
  }
}
export default new ManagerDataService();